import { useTheme } from '@mui/material';

import { themeColors } from '~/theme';

export const useSxStyles = () => {
  const theme = useTheme();
  const captionStyles = theme.typography.caption;

  const currentSelectionLine = {
    fontSize: captionStyles.fontSize?.toString() ?? 'inherit',
    color: captionStyles.color?.toString() ?? 'inherit',
    textTransform: 'initial',
  };

  return {
    root: {
      padding: theme.spacing(1, 2),
      backgroundColor: themeColors.background.grey,
    },
    selectedIcon: {
      verticalAlign: 'middle',
    },
    paramsFieldSet: {
      padding: theme.spacing(1.5, 2),
      display: 'flex',
      gap: theme.spacing(1),
    },
    actionsFieldSet: {
      padding: theme.spacing(1, 2),
      display: 'flex',
      alignItems: 'end',
    },
    divider: {
      margin: theme.spacing(1, 0),
      height: 'auto',
    },
    selectorToggle: {},
    currentSelectionType: {
      ...currentSelectionLine,
      whiteSpace: 'nowrap',
    },
    currentSelectionLine,
    popper: {
      zIndex: 20,
    },
    popperPaper: {
      display: 'flex',
    },
  };
};
